import React, { forwardRef, useImperativeHandle } from 'react'
import WhatyougetItem from './WhatyougetItem'

const WhatYouGetSection = forwardRef(({ WhatYouGetList, setWhatYouGetList, setWhatYouGetDelete, formErrors, setFormErrors, disabled, setEditDisabled }, ref) => {

    //#region validations
    const validateWhatYouGetSection = () => {
        let error = {};
        const keys = Object.keys(WhatYouGetList);
        keys?.filter((prev) => prev !== "OtherInfo")?.forEach((keyName) => {
            if (WhatYouGetList?.[keyName]?.length <= 0) {
                error[keyName] = "Input is Mandatory, Cannot leave blank";
            }
        })
        return error;
    }
    //#endregion

    // Expose the childFunction to the parent's ref
    useImperativeHandle(ref, () => ({
        canValidate: false,
        validateWhatYouGetSection: validateWhatYouGetSection
    }))

    return (
        <>
            <div className="container-fluid form_border my-2 py-3">
                <h6 className="mb-3">
                    <strong>What you get</strong>
                </h6>

                <WhatyougetItem
                    title="Inclusion"
                    id="Inclusion"
                    placeholder="Inclusion"
                    isRequired={true}
                    maxLength={200}
                    maxCollectionCount={15}
                    keyName="Inclusion"
                    WhatYouGetList={WhatYouGetList}
                    setWhatYouGetList={setWhatYouGetList}
                    setWhatYouGetDelete={setWhatYouGetDelete}
                    formErrors={formErrors}
                    setFormErrors={setFormErrors}
                    disabled={disabled}
                    setEditDisabled={setEditDisabled}
                />

                <WhatyougetItem
                    title="Exclusion"
                    id="Exclusion"
                    placeholder="Exclusion"
                    isRequired={true}
                    maxLength={200}
                    maxCollectionCount={15}
                    keyName="Exclusion"
                    WhatYouGetList={WhatYouGetList}
                    setWhatYouGetList={setWhatYouGetList}
                    setWhatYouGetDelete={setWhatYouGetDelete}
                    formErrors={formErrors}
                    setFormErrors={setFormErrors}
                    disabled={disabled}
                    setEditDisabled={setEditDisabled}
                />

                <WhatyougetItem
                    title="Things To Avoid"
                    id="ThingsToAvoid"
                    placeholder="Things To Avoid"
                    isRequired={true}
                    maxLength={200}
                    maxCollectionCount={15}
                    keyName="ThingsToAvoid"
                    WhatYouGetList={WhatYouGetList}
                    setWhatYouGetList={setWhatYouGetList}
                    setWhatYouGetDelete={setWhatYouGetDelete}
                    formErrors={formErrors}
                    setFormErrors={setFormErrors}
                    disabled={disabled}
                    setEditDisabled={setEditDisabled}
                />

                <WhatyougetItem
                    title="Things To be Carried"
                    id="ThingsToCarried"
                    placeholder="Things To be Carried"
                    isRequired={true}
                    maxLength={200}
                    maxCollectionCount={15}
                    keyName="ThingsToCarried"
                    WhatYouGetList={WhatYouGetList}
                    setWhatYouGetList={setWhatYouGetList}
                    setWhatYouGetDelete={setWhatYouGetDelete}
                    formErrors={formErrors}
                    setFormErrors={setFormErrors}
                    disabled={disabled}
                    setEditDisabled={setEditDisabled}
                />

                <WhatyougetItem
                    title="Others Information"
                    id="OtherInfo"
                    placeholder="Others Information"
                    isRequired={false}
                    maxLength={200}
                    maxCollectionCount={15}
                    keyName="OtherInfo"
                    WhatYouGetList={WhatYouGetList}
                    setWhatYouGetList={setWhatYouGetList}
                    setWhatYouGetDelete={setWhatYouGetDelete}
                    formErrors={formErrors}
                    setFormErrors={setFormErrors}
                    disabled={disabled}
                    setEditDisabled={setEditDisabled}
                />


            </div>
        </>
    )
});

export default WhatYouGetSection